import React, { useEffect, useState } from "react";
import { Collapse, Stack } from "@mui/material";
import Paper from "@mui/material/Paper";
import _ from "lodash";
import moment from "moment";
import {
  context_styles,
  list_styles,
} from "../../context/context_builder_dark_styles";
import "../../context/context_dark.css";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import { useSpring, animated } from "@react-spring/web";
import { useSelector, useDispatch } from "react-redux";
import TreeItem from "@mui/lab/TreeItem";
import { Projects } from "./Projects";
import { StyledAutocompleteDark } from "../../context/context_components/styled_autocomplete";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePickerWhite } from "./DatePickerWhite";
import {
  setSessionAuditData,
  setStoreData,
  setActiveProjectIC,
  setUserData,
  setAllData,
  setAuditList,
  setSelectedOption,
  setSelectedType,
  setAuditId,
  setLoading,
  setSearchEntity,
  setSelectedCategory,
  setSelectedStore,
  resetState,
  resetStateToDefault,
} from "../../store/comprehensiveImageViewer/imageViewerlikeContext";
import {
  clearImageData,
  getDataSuccess,
  getMobileDataSuccess,
  getSdkDataSuccess,
  setNewExpandedNode,
} from "../../store/comprehensiveImageViewer/imageViewerSlice";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import {
  setSnackbarMessage,
  setSnackbarMessageSeverity,
  setSnackbarOpen,
} from "../../store/comprehensiveImageViewer/feedbackSlice";

export default function Default(props) {
  const { projectInfo, projects } = useSelector(
    (state) => state.projectInfoStore
  );
  const {
    stores,
    users,
    sessionAudits,
    allData,
    searchEntity,
    selectedCategory,
    selectedStore,
    auditList,
    selectedType,
    selectedAudit,
    isLoading,
    selectedOption,
    activeProjectIC,
  } = useSelector((state) => state.imageVCStore);

  // console.log(activeProjectIC)
  const { treeDataRedux, dataType } = useSelector(
    (state) => state.imageViewerStore
  );
  const useAutoCompleteStyles = makeStyles({
    option: {
      fontSize: "0.875rem",
    },
  });

  const autocomplete_classes = useAutoCompleteStyles();
  const config = projects.filter(
    (r) => r.country === projectInfo[0] && r.env === projectInfo[1]
  )[0];
  const { color, col_100 } = useSelector((state) => state.themeStore);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const baseProject = projectInfo[2];
  const dispatch = useDispatch();
  const [date, setDate] = useState(null);
  const [enterDate, setEnterDate] = useState(null);

  const [springs, api] = useSpring(() => ({
    from: {
      y: 0,
    },
    config: {
      mass: 7,
    },
  }));

  function findNodeIdByName(tree, nodeName) {
    if (tree.name === nodeName) {
      return tree.id;
    }

    if (tree.children && tree.children.length > 0) {
      for (const child of tree.children) {
        const nodeId = findNodeIdByName(child, nodeName);
        if (nodeId) {
          return nodeId;
        }
      }
    }

    return null; // Node not found
  }

  function findNodeIdByPath(tree, nodePath) {
    let currentNode = tree;

    for (const nodeName of nodePath) {
      let found = false;

      if (currentNode.name === nodeName) {
        found = true;
      } else if (currentNode.children) {
        for (const child of currentNode.children) {
          if (child.name === nodeName) {
            currentNode = child;
            found = true;
            break;
          }
        }
      }

      if (!found) {
        // Node not found in the path
        return null;
      }
    }

    // Return the ID of the last node in the path
    return currentNode.id;
  }

  useEffect(() => {
    const fetchData = async () => {
      if (enterDate && enterDate !== "Invalid date") {
        dispatch(setSearchEntity(enterDate));
        let refresh_selected_option = { ...selectedOption };
        Object.keys(refresh_selected_option).map((option) => {
          refresh_selected_option[option] = "";
        });
        dispatch(setSelectedOption(refresh_selected_option));
        const project = "thailand-live";
        dispatch(setLoading(true));

        try {
          const res = await axios.post("/get_context/get_info_of_date", {
            date: enterDate,
            config: activeProjectIC,
          });

          let stores = [];
          let users = [];
          let session_audit = [];
          const data_on_date = res.data[enterDate];

          if (data_on_date.length < 1) {
            dispatch(setSnackbarOpen(true));
            dispatch(setSnackbarMessage("No Data Available!"));
            dispatch(setSnackbarMessageSeverity("info"));
          }

          for (let i = 1; i < data_on_date.length; i++) {
            let store = data_on_date[i][2];
            let user = data_on_date[i][7];
            let sessionAudit = data_on_date[i][0];

            stores.push(store);
            users.push(user);
            session_audit.push(sessionAudit);
          }

          stores = [...new Set(stores)];
          dispatch(setStoreData(stores));
          users = [...new Set(users)];
          dispatch(setUserData(users));
          session_audit = [...new Set(session_audit)];
          dispatch(setSessionAuditData(session_audit));
          dispatch(setLoading(false));

          dispatch(setAllData(data_on_date));
        } catch (error) {
          console.error("Error fetching data:", error);
          dispatch(setLoading(false));
        }
      }
    };

    fetchData();
  }, [enterDate]);

  useEffect(() => {
    if (searchEntity) {
      const date = searchEntity;
      const month = moment(date, "YYYY-MM-DD").format("MMM");
      //console.log(month)
      let cycle;
      const monthM = moment(date).format("M");
      //console.log(monthM)
      if (monthM < 7) {
        cycle = "1";
      } else {
        cycle = "2";
      }
      //const cycleMonth=[cycle,month]
      //console.log(cycleMonth)
      //console.log(selectedOption["user"])
      if (selectedOption["user"]) {
        //console.log("user")
        const nodeIdOfUser = findNodeIdByName(treeDataRedux, "Users");
        const nodeIdOfUserData = findNodeIdByName(
          treeDataRedux,
          selectedOption["user"]
        );
        //console.log(selectedAudit)
        if (selectedAudit) {
          const nodeIdOfSelectedAudit = findNodeIdByName(
            treeDataRedux,
            selectedAudit
          );
          let newValues;
          if (dataType === "Archived") {
            newValues = [
              "root",
              cycle,
              month,
              date,
              nodeIdOfUser,
              nodeIdOfUserData,
              nodeIdOfSelectedAudit,
            ];
          } else {
            newValues = [
              "root",
              nodeIdOfUser,
              nodeIdOfUserData,
              nodeIdOfSelectedAudit,
            ];
          }

          //console.log(newValues)
          dispatch(setNewExpandedNode(newValues));
        } else {
          let newValues;
          if (dataType === "Archived") {
            newValues = [
              "root",
              cycle,
              month,
              date,
              nodeIdOfUser,
              nodeIdOfUserData,
            ];
          } else {
            newValues = ["root", nodeIdOfUser, nodeIdOfUserData];
          }

          //console.log(newValues)
          dispatch(setNewExpandedNode(newValues));
        }
      }
      if (selectedOption["store"]) {
        //console.log("store")
        const curStore = selectedOption["store"];
        //console.log(curStore)
        const nodeIdOfStores = findNodeIdByName(treeDataRedux, "Stores");
        const nodeIdOfStoresData = findNodeIdByName(treeDataRedux, curStore);
        if (selectedAudit) {
          //console.log("selectedAudit",selectedAudit)
          const sessionAndAuditId = [];
          const auditIdIndex = allData[0].indexOf("auditID");
          const sessionAuditIndex = allData[0].indexOf("session_audit");
          const storeIndex = allData[0].indexOf("address");
          const categoryAndStore = `${selectedCategory}-${selectedStore}`;
          //console.log(categoryAndStore)
          allData.map((row) => {
            if (row.includes(curStore)) {
              if (selectedAudit === row[auditIdIndex])
                sessionAndAuditId.push(
                  row[sessionAuditIndex],
                  row[auditIdIndex]
                );
            }
          });
          //console.log(sessionAndAuditId);

          const nodeIdOfCurStoreSessionAudit = findNodeIdByName(
            treeDataRedux,
            sessionAndAuditId[0]
          );
          let cycleMon;
          if (cycle === 1) {
            cycleMon = "Jan-Jun";
          } else {
            cycleMon = "Jul-Dec";
          }
          const nodePathToFind = [
            "Cycle",
            cycleMon,
            month,
            date,
            "Stores",
            curStore,
            sessionAndAuditId[0],
            categoryAndStore,
          ];
          //console.log(nodePathToFind)
          const nodeIdOfCategoryAndStore = findNodeIdByPath(
            treeDataRedux,
            nodePathToFind
          );
          //console.log(nodeId)
          //const nodeIdOfCategoryAndStore=findNodeIdByName(treeDataRedux,categoryAndStore);
          //console.log(nodeIdOfCategoryAndStore)
          const nodeIdOfCurStoreCurSessionAuditId = findNodeIdByName(
            treeDataRedux,
            sessionAndAuditId[1]
          );

          let newValues;
          if (dataType === "Archived") {
            //console.log(nodePathToFind)

            newValues = [
              "root",
              cycle,
              month,
              date,
              nodeIdOfStores,
              nodeIdOfStoresData,
              nodeIdOfCurStoreSessionAudit,
              nodeIdOfCategoryAndStore,
              nodeIdOfCurStoreCurSessionAuditId,
            ];
          } else {
            const nodePathToFind = [
              date,
              "Stores",
              curStore,
              sessionAndAuditId[0],
              categoryAndStore,
            ];
            const nodeIdOfCategoryAndStore = findNodeIdByPath(
              treeDataRedux,
              nodePathToFind
            );
            newValues = [
              "root",
              nodeIdOfStores,
              nodeIdOfStoresData,
              nodeIdOfCurStoreSessionAudit,
              nodeIdOfCategoryAndStore,
              nodeIdOfCurStoreCurSessionAuditId,
            ];
          }

          // console.log(newValues)
          dispatch(setNewExpandedNode(newValues));
        } else {
          let newValues;
          if (dataType === "Archived") {
            newValues = [
              "root",
              cycle,
              month,
              date,
              nodeIdOfStores,
              nodeIdOfStoresData,
            ];
          } else {
            newValues = ["root", nodeIdOfStores, nodeIdOfStoresData];
          }

          // console.log(newValues)
          dispatch(setNewExpandedNode(newValues));
        }
      }
      if (selectedOption["session_audit"]) {
        //console.log("session_audit")
        const curSessionAudit = selectedOption["session_audit"];
        //console.log(curSessionAudit)
        const nodeIdOfStores = findNodeIdByName(treeDataRedux, "Stores");
        // console.log(nodeIdOfStores)
        if (selectedAudit) {
          const storeAndAuditId = [];
          const auditIdIndex = allData[0].indexOf("auditID"); //1
          const sessionAuditIndex = allData[0].indexOf("session_audit"); //0
          const storeIndex = allData[0].indexOf("address"); //2
          const categoryAndStore = `${selectedCategory}-${selectedStore}`;
          //console.log(categoryAndStore)
          allData.map((row) => {
            if (row.includes(curSessionAudit)) {
              if (selectedAudit === row[auditIdIndex])
                storeAndAuditId.push(row[storeIndex], row[auditIdIndex]);
            }
          });
          //console.log(storeAndAuditId)

          const nodeIdOfStoresData = findNodeIdByName(
            treeDataRedux,
            storeAndAuditId[0]
          );
          //console.log(nodeIdOfStoresData)
          const nodeIdOfCurStoreSessionAudit = findNodeIdByName(
            treeDataRedux,
            curSessionAudit
          );
          //console.log(nodeIdOfCurStoreSessionAudit)
          let cycleMon;
          if (cycle === 1) {
            cycleMon = "Jan-Jun";
          } else {
            cycleMon = "Jul-Dec";
          }
          const nodePathToFind = [
            "Cycle",
            cycleMon,
            month,
            date,
            "Stores",
            storeAndAuditId[0],
            curSessionAudit,
            categoryAndStore,
          ];
          //console.log(nodePathToFind)
          const nodeIdOfCategoryAndStore = findNodeIdByPath(
            treeDataRedux,
            nodePathToFind
          );
          // const nodeIdOfCategoryAndStore=findNodeIdByName(treeDataRedux,categoryAndStore);
          // console.log(nodeIdOfCategoryAndStore)
          const nodeIdOfCurStoreCurSessionAuditId = findNodeIdByName(
            treeDataRedux,
            storeAndAuditId[1]
          );
          // console.log(nodeIdOfCurStoreCurSessionAuditId)

          let newValues;
          //console.log(dataType);
          if (dataType === "Archived") {
            newValues = [
              "root",
              cycle,
              month,
              date,
              nodeIdOfStores,
              nodeIdOfStoresData,
              nodeIdOfCurStoreSessionAudit,
              nodeIdOfCategoryAndStore,
              nodeIdOfCurStoreCurSessionAuditId,
            ];
          } else {
            const nodePathToFind = [
              date,
              "Stores",
              storeAndAuditId[0],
              curSessionAudit,
              categoryAndStore,
            ];
            const nodeIdOfCategoryAndStore = findNodeIdByPath(
              treeDataRedux,
              nodePathToFind
            );
            newValues = [
              "root",
              nodeIdOfStores,
              nodeIdOfStoresData,
              nodeIdOfCurStoreSessionAudit,
              nodeIdOfCategoryAndStore,
              nodeIdOfCurStoreCurSessionAuditId,
            ];
          }
          //console.log(newValues)
          dispatch(setNewExpandedNode(newValues));
        } else {
          let newValues;
          if (dataType === "Archived") {
            newValues = ["root", cycle, month, date, nodeIdOfStores];
          } else {
            newValues = ["root", nodeIdOfStores];
          }

          //console.log(newValues)
          dispatch(setNewExpandedNode(newValues));
        }
      }
    }
  }, [
    searchEntity,
    selectedOption,
    selectedAudit,
    setSelectedCategory,
    setSelectedStore,
  ]);

  useEffect(() => {
    api.start({
      from: {
        opacity: 0,
        y: -15 + "%",
      },
      to: {
        opacity: 1,
        y: 0 + "%",
      },
    });
    if (searchEntity) {
      setDate(searchEntity);
      // setEnterDate(searchEntity);
    }
    if (projectInfo[0] === "Thailand") {
      dispatch(setActiveProjectIC("thailand-live"));
    } else if (projectInfo[0] === "India") {
      dispatch(setActiveProjectIC("india-live"));
    }
  }, []);

  let searchMode = "Date";

  const handleTextChange = async (newDate) => {
    const formattedDate = moment(newDate).format("YYYY-MM-DD");

    if (newDate) {
      dispatch(clearImageData());
      dispatch(setAuditList([]));
      dispatch(setSnackbarOpen(true));
      dispatch(setSnackbarMessage("Please Select the fields."));
    }
    const isValidDate = (formattedDate) => {
      const dateCheck = new Date(formattedDate);
      const isInvalid = isNaN(dateCheck.getTime());
      return (
        !isInvalid && dateCheck.toISOString().split("T")[0] === formattedDate
      );
    };

    if (isValidDate) {
      dispatch(setSearchEntity(formattedDate));
      setDate(formattedDate);
      setEnterDate(formattedDate);
    } else {
      dispatch(setSnackbarOpen(true));
      dispatch(setSnackbarMessage("Enter a valid date!"));
      dispatch(setSnackbarMessageSeverity("error"));
      return;
    }
  };

  const handleOptionChange = async (e, type) => {
    let updated_selected_option = { ...selectedOption };
    Object.keys(updated_selected_option).map((option) => {
      if (option === type) {
        updated_selected_option[option] = e;
      } else {
        updated_selected_option[option] = "";
      }
    });
    dispatch(setAuditId(""));
    dispatch(clearImageData());

    let audit_list = [];

    const auditIdIndex = allData[0].indexOf("auditID");
    const categoryIndex = allData[0].indexOf("category");
    const storeTypeIndex = allData[0].indexOf("store_type");
    const maxTimeIndex = allData[0].indexOf("max_time");
    allData.map((row) => {
      if (row.includes(e)) {
        audit_list.push({
          audit: row[auditIdIndex],
          category: row[categoryIndex],
          store_type: row[storeTypeIndex],
          max_time: row[maxTimeIndex],
          latest_audit: "false",
        });
      }
    });

    audit_list.sort(
      (a, b) => new Date(b.max_time).getTime() - new Date(a.max_time).getTime()
    );

    if (type === "session_audit" && activeProjectIC === "india-live") {
      // console.log("ji")

      await axios
        .post("/getAzureData/downloadDataFromAxiosAndFilterOutData", {
          date: searchEntity,
          session_audit: e,
        })
        .then((response) => {
          if (response.status === 200) {
            dispatch(getMobileDataSuccess(response.data));
          } else {
            //console.error(`HTTP Error: ${response.status}`);
            setOpenSnackbar(true);
            setTimeout(() => {
              setOpenSnackbar(false);
            }, 5000);
          }
        })
        .catch((error) => {
          //console.error("Error:", error);
          setOpenSnackbar(true);
          setTimeout(() => {
            setOpenSnackbar(false);
          }, 5000);
        });
      //console.log(resData.data);
    }
    if (type === "session_audit") {
      let newProject;
      if (activeProjectIC === "thailand-live") {
        newProject = "thailand";
      } else {
        newProject = "india_live";
      }
      await axios
        .post("/get_context/get_sdk_data", {
          session_audit: e,
          project: newProject,
        })
        .then((response) => {
          if (response.status === 200) {
            dispatch(getSdkDataSuccess(response.data.Tables));
          } else {
            //console.error(`HTTP Error: ${response.status}`);
            setOpenSnackbar(true);
            setTimeout(() => {
              setOpenSnackbar(false);
            }, 5000);
          }
        })
        .catch((error) => {
          //console.error("Error:", error);
          setOpenSnackbar(true);
          setTimeout(() => {
            setOpenSnackbar(false);
          }, 5000);
        });
    }
    dispatch(setAuditList(audit_list));
    dispatch(setSelectedOption(updated_selected_option));
  };
  const handleChangeSelectedType = () => {
    if (selectedType === "category") {
      dispatch(setSelectedType("audits"));
    } else if (selectedType === "audits") {
      dispatch(setSelectedType("category"));
    }
  };
  const fetchAuditDetails = async (auditId, category, store_type) => {
    dispatch(setLoading(true));
    dispatch(setAuditId(auditId));
    dispatch(setSelectedCategory(category));
    dispatch(setSelectedStore(store_type));
    dispatch(clearImageData());

    //const project="thailand-live";
    const res = await axios.post("/get_context/get_info_of_audit", {
      auditID: auditId,
      config: activeProjectIC,
    });

    dispatch(getDataSuccess(res.data));
    dispatch(setLoading(false));
  };

  // console.log(selectedOption, "options");

  return (
    <animated.div style={{ ...springs }}>
      <Paper elevation={10} sx={context_styles}>
        {/* Search Mode */}
        {/* {searchMode} */}
        {/* <DefaultSearchMode /> */}
        {/* project info/switcher */}
        <Stack
          spacing={1.5}
          sx={{ p: 1 }}
          direction="row"
          className="search-container"
        >
          <ChevronRightIcon
            className="search-mode-toggle"
            sx={{
              backgroundColor: col_100,
            }}
          />
          {/* <input
          className="search-field-dark"
          placeholder={"yyyy-mm-dd"}
          onChange={handleTextChange}
          defaultValue={searchEntity}
          onKeyDown={handleKeyDown}
        /> */}
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Stack
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
              direction="row"
              spacing={1}
            >
              <DatePickerWhite
                sx={{
                  width: "11rem",
                  border: "none",
                  borderRadius: "5px",
                  "& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-adornedEnd.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root":
                    {
                      height: "40px",
                    },
                }}
                value={date}
                onChange={(newDate) => handleTextChange(newDate)}
                renderInput={(params) => (
                  <TextField variant="outlined" size="small" {...params} />
                )}
                format="YYYY-MM-DD"
              />
            </Stack>
          </LocalizationProvider>
        </Stack>
        <Collapse in={stores.length > 0} timeout={350} unmountOnExit>
          <Stack spacing={0}>
            {stores.length > 0 && (
              <StyledAutocompleteDark
                sx={{ width: "15rem" }}
                classes={{
                  option: autocomplete_classes.option,
                }}
                id="size-small-outlined-multi"
                size="small"
                value={selectedOption["store"]}
                noOptionsText="Loading..."
                componentsProps={{
                  popper: { style: { width: "fit-content" } },
                }}
                options={stores}
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder={`Stores   ( ${stores.length} )`}
                  />
                )}
                onChange={(event, value) => handleOptionChange(value, "store")}
              />
            )}
            {users.length > 0 && (
              <StyledAutocompleteDark
                sx={{ width: "15rem" }}
                classes={{
                  option: autocomplete_classes.option,
                }}
                id="size-small-outlined-multi"
                size="small"
                value={selectedOption["user"]}
                noOptionsText="Loading..."
                componentsProps={{
                  popper: { style: { width: "fit-content" } },
                }}
                options={users}
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder={`Users   ( ${users.length} )`}
                  />
                )}
                onChange={(event, value) => handleOptionChange(value, "user")}
              />
            )}
            {sessionAudits.length > 0 && (
              <StyledAutocompleteDark
                sx={{ width: "15rem" }}
                classes={{
                  option: autocomplete_classes.option,
                }}
                id="size-small-outlined-multi"
                size="small"
                value={selectedOption["session_audit"]}
                noOptionsText="Loading..."
                componentsProps={{
                  popper: { style: { width: "fit-content" } },
                }}
                options={sessionAudits}
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder={`Session Audits   ( ${sessionAudits.length} )`}
                  />
                )}
                onChange={(event, value) =>
                  handleOptionChange(value, "session_audit")
                }
              />
            )}
          </Stack>
        </Collapse>
        <Collapse in={auditList.length > 0} timeout={350} unmountOnExit>
          {auditList.length > 0 && (
            <Stack spacing={1.5} sx={{ margin: "1rem auto" }}>
              <span
                className="list-header-dark"
                onClick={handleChangeSelectedType}
              >
                {selectedType === "category"
                  ? `Category (${auditList.length})`
                  : `Audits (${auditList.length})`}
              </span>
              <div style={list_styles} className="context-scroll-dark">
                <Stack spacing={1.5}>
                  {auditList &&
                    auditList.map((item) => (
                      <span
                        className={`list-item-dark ${
                          item.audit === selectedAudit
                            ? "selected-audit-dark"
                            : ""
                        }`}
                        onClick={() =>
                          fetchAuditDetails(
                            item.audit,
                            item.category,
                            item.store_type
                          )
                        }
                      >
                        {selectedType === "category"
                          ? item.category.replace(/_/g, " ") +
                            " | " +
                            item.store_type
                          : item.audit}
                      </span>
                    ))}
                </Stack>
              </div>
            </Stack>
          )}
        </Collapse>
        <Projects />
      </Paper>
    </animated.div>
  );
}
